import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

import { FavoritePairsListItemRoot } from './favorite-pairs-list-item'

type FavoritePairsListItemSkeletonProps = {
  parity?: 'even' | 'odd'
}

const Item: React.FC<FavoritePairsListItemSkeletonProps> = ({
  parity = 'even',
}) => (
  <FavoritePairsListItemRoot data-parity={parity}>
    <CurrencyInfo>
      <Skeleton height={39} width={39} variant="circular" />
      <PairInformationCurrencySkeleton>
        <Skeleton height={12} width="80%" />
        <Skeleton height={8} width="60%" />
      </PairInformationCurrencySkeleton>
    </CurrencyInfo>
    <Footer>
      <FavoritePairsListInfoSkeleton>
        <Metrics>
          <Skeleton height={8} />
          <Skeleton height={8} />
          <Skeleton height={8} />
          <Skeleton height={8} />
        </Metrics>
        <Metrics>
          <Skeleton height={8} width={32} />
          <Skeleton height={8} width={18} />
          <Skeleton height={8} width={24} />
          <Skeleton height={8} width={32} />
        </Metrics>
      </FavoritePairsListInfoSkeleton>
      <Action>
        <ButtonSkeleton height={24} width={50} />
        <ActionSeparator />
        <ButtonSkeleton height={24} width={50} />
      </Action>
    </Footer>
  </FavoritePairsListItemRoot>
)

const List: React.FC<{ count?: number }> = ({ count = 10 }) =>
  Array.from({ length: count }).map((_, index) => (
    <Item key={index} parity={index % 2 === 0 ? 'even' : 'odd'} />
  ))

export const FavoritePairsListItemSkeleton = {
  Item,
  List,
}

const CurrencyInfo = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 2fr auto;

  padding: 10px;
  gap: 10px;
  padding-bottom: 7px;
  border-bottom: 1px solid var(--background-3);
`

const Action = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  gap: 6px;

  justify-content: center;
  align-items: center;
`

const ActionSeparator = styled.div`
  height: 16px;
  width: 1px;
  background: var(--background-3);
`

const PairInformationCurrencySkeleton = styled.div`
  display: grid;
  gap: 4px;
`

const FavoritePairsListInfoSkeleton = styled.div`
  display: grid;
  gap: 4px;
`

const Footer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  padding-inline: 10px;
`

const ButtonSkeleton = styled(Skeleton)`
  border-radius: 8px;
`

const Metrics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
`
